import carousel from './freemode-carousel';

const infographicCarousel = document.querySelector('.InfographicCarousel-swiper');
if (infographicCarousel) {
  const numSlides = infographicCarousel.dataset.slidesperview
    ? infographicCarousel.dataset.slidesperview
    : 3;
  const slidesLength = infographicCarousel.dataset.totalslides;
  const fitOnScreen = slidesLength <= numSlides;

  if (fitOnScreen) {
    infographicCarousel.classList.add('fits-on-screen');
  }

  carousel(infographicCarousel, {
    loop: false,
    slidesPerView: 1.333,
    spaceBetween: 20,
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,
    breakpoints: {
      768: {
        slidesPerView: 2.333,
      },
      1024: {
        enabled: !fitOnScreen,
        slidesPerView: 3,
        spaceBetween: 32,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 56,
      },
    },
  });
}
